import {Row} from "react-bootstrap";
import {FC} from "react";
import ContextThanhToanProvider from "../../../phan-he-thu-ngan/context/PhanHeThuNganContext";
import {TableDanhSachPhieuXuatKhoBaoHiem} from "./TableDanhSachPhieuXuatKhoBaoHiem";
import ThongTinPhieuXuat from "./ThongTinPhieuXuat";
import ThongTinChiTietPhieuXuat from "./ThongTinChiTietPhieuXuat";
import clsx from "clsx";

type Props = {
    searchData: any;
    setSearchData: any;
    handleRefreshData: any;
    summaryStatus?: object;
    setSummaryStatus?: any;
    selectedRow: object;
    setSelectedRow: any;
    warehouseId: number;
    dsVatTu: any;
    setDsVatTu: any;
    warehouseExportType: any;
    className?: string;
    classNameTablePhieuXuat?: string;
}

const XuatKhoBaoHiem: FC<Props> = (props) => {
    let {
        searchData,
        setSearchData,
        handleRefreshData,
        summaryStatus,
        selectedRow = {},
        warehouseId,
        dsVatTu,
        setDsVatTu,
        setSelectedRow,
        warehouseExportType,
        classNameTablePhieuXuat = '',
        className = '',
    } = props;

    return (
        <div className={clsx(className,"reception-list bg-gray")}>
            <ContextThanhToanProvider>
                <Row className="phanHeVienPhi h-100">
                    <div className={clsx(
                        "pe-0 dsBenhNhan spaces width-27_4",
                        !classNameTablePhieuXuat && "h-calc-vh-180",
                        classNameTablePhieuXuat
                    )}>
                        <TableDanhSachPhieuXuatKhoBaoHiem
                            searchData={searchData}
                            setSearchData={setSearchData}
                            handleRefreshData={handleRefreshData}
                            summaryStatus={summaryStatus}
                            selectedRow={selectedRow}
                        />
                    </div>
                    <div className="pl-0 dsBenhNhan ml-pt-0_6 spaces border width-72 ">
                        <ThongTinChiTietPhieuXuat
                            selectedRow={selectedRow}
                        />
                        <ThongTinPhieuXuat
                            warehouseId={warehouseId}
                            dsVatTu={dsVatTu}
                            setDsVatTu={setDsVatTu}
                            selectedRow={selectedRow}
                            setSelectedRow={setSelectedRow}
                            handleRefreshData={handleRefreshData}
                            warehouseExportType={warehouseExportType}
                        />
                    </div>
                </Row>
            </ContextThanhToanProvider>
        </div>
    );
};

export default XuatKhoBaoHiem;
